import moment from 'moment';

export const canPlaceOrder = (
  selectedDate,
  operationStartTime,
  operationEndTime,
  timetoCompare = moment()
) => {
  const start = moment(
    new Date(
      `${moment(selectedDate, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${operationStartTime}`
    )
  );
  const end = moment(
    new Date(`${moment(selectedDate, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${operationEndTime}`)
  );
  const current = timetoCompare;

  if (moment(selectedDate, 'MM/DD/YYYY') > current) {
    return true;
  }

  if (current.hours() < start.hours()) {
    current.add(1, 'days');
  }

  if (end.isSameOrBefore(start)) {
    end.add(1, 'days');
  }

  return current.isBetween(start, end, null, '[]');
};

// export const generateTimeSlots = (
//   selectedDate,
//   operationStartTime,
//   operationEndTime,
//   slotPeriodToday = 30,
//   slotPeriodNextDay = 30,
//   bufferStartTime = 0
// ) => {
//   let end = moment(
//     new Date(`${moment(selectedDate, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${operationEndTime}`)
//   );
//   let current = moment();
//   const isToday =
//     moment(selectedDate, 'MM/DD/YYYY').format('MM/DD/YYYY') === current.format('MM/DD/YYYY');
//   if (!isToday) {
//     current = moment(
//       new Date(
//         `${moment(selectedDate, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${operationStartTime}`
//       )
//     );
//   }

//   if (end.isSameOrBefore(current)) {
//     end.add(1, 'days');
//   }

//   if (isToday) {
//     const start = moment(
//       new Date(
//         `${moment(selectedDate, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${operationStartTime}`
//       )
//     );
//     if (current < start) {
//       current = start.add(bufferStartTime, 'minute');
//     } else {
//       current.add(bufferStartTime, 'minute');
//     }
//   }

//   const timeSlots = [];
//   let slotStart = current.clone();
//   const slotsEnd = isToday ? end.clone().add(bufferStartTime, 'minute') : end.clone();

//   while (slotStart.isBefore(slotsEnd)) {
//     const slotStartDate = slotStart.format('MM/DD/YYYY');
//     const slotEnd = slotStart.clone().add(isToday ? slotPeriodToday : slotPeriodNextDay, 'minute');
//     timeSlots.push({
//       deliveryDate: slotStartDate,
//       start: slotStart.format('hh:mm A'),
//       end: slotEnd.format('hh:mm A'),
//       active: true,
//       slotTime: `${slotStart.format('hh:mm A')} - ${slotEnd.format('hh:mm A')}`,
//     });
//     slotStart = slotEnd;
//   }

//   return timeSlots;
// };

// export const isDeliveryRestricted = ({
//   selectedDate,
//   slotDate,
//   slotStartTime,
//   restrictedDeliveryDay,
//   restrictedDeliveryStartTime,
//   restrictedDeliveryEndTime,
//   currentDay,
// }) => {
//   const startDateTime = moment(
//     new Date(`${moment(slotDate, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${slotStartTime}`)
//   );

//   // canPlaceOrder logic works reverse for restricted time slot
//   return (
//     restrictedDeliveryDay?.toLowerCase() === currentDay &&
//     canPlaceOrder(
//       selectedDate,
//       restrictedDeliveryStartTime,
//       restrictedDeliveryEndTime,
//       startDateTime
//     )
//   );
// };

//New method created to create delivery time slots
export function GenerateTimeSlotsForDelivery({
  selectedDeliveryOption, // standard ,priority or pickup  priority
  KitchenInfoData,
  onLoadInfoResponse,
}) {
  const operation_start_time = KitchenInfoData?.operation_start_time; // '08:20 AM'
  const operation_end_time = KitchenInfoData?.operation_end_time; //'08:53 PM'
  const StandardDeliveryObj =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.standard_delivery;
  const PriorityDeliveryObj =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.priority_delivery;

  const AssignGap = () => {
    /*IMPORTANT NOTE --> If you change code for timegap then it has aslo be change 
    IN below method GenerateAllTimeSlotsForDelivery()  last block return if blocks */
    if (KitchenInfoData?.delivered_by === 'kitchen') {
      if (selectedDeliveryOption === 'standard') {
        return 45;
      }

      if (selectedDeliveryOption === 'priority') {
        return 30;
      }

      if (selectedDeliveryOption === 'pickup') {
        return 20;
      }
    }

    // We have to get regionalbranch flags for this from onloadresponse
    if (KitchenInfoData?.delivered_by !== 'kitchen') {
      if (selectedDeliveryOption === 'standard') {
        return StandardDeliveryObj?.slotStartGap;
      }

      if (selectedDeliveryOption === 'priority') {
        return PriorityDeliveryObj?.slotStartGap;
      }

      if (selectedDeliveryOption === 'pickup') {
        return 20;
      }
    }

    return 60;
  };

  const now = moment();
  const slotStartGap = AssignGap();
  const slotGapBetween = 30;
  const closingSoonMinutes = 30;

  const today = now.format('MM/DD/YYYY');

  let storeStart = moment(`${today} ${operation_start_time}`, 'MM/DD/YYYY hh:mm A');
  let storeEnd = moment(`${today} ${operation_end_time}`, 'MM/DD/YYYY hh:mm A');

  // Handle overnight timing
  if (storeEnd.isSameOrBefore(storeStart)) {
    storeEnd.add(1, 'day');
  }

  const tomorrowStart = storeStart.clone().add(1, 'day');
  const next_opening_time = tomorrowStart.format('hh:mm A');

  let store_status = 'open';

  // Before store opens
  if (now.isBefore(storeStart)) {
    const diffMinutes = storeStart.diff(now, 'minutes');

    if (diffMinutes < 60) {
      store_status = `Store opens in ${diffMinutes} mins`;
    } else {
      const hours = Math.floor(diffMinutes / 60);
      const mins = diffMinutes % 60;

      if (mins === 0) {
        store_status = `Store opens in ${hours} hour${hours > 1 ? 's' : ''}`;
      } else {
        store_status = `Store opens in ${hours}h ${mins}m`;
      }
    }
  }
  // After store closes
  else if (now.isSameOrAfter(storeEnd)) {
    return {
      success: false,
      store_status: 'store is closed for today',
      next_opening_time,
      delivery_date: null,
      delivery_time_slot: null,
      selectedDeliveryOption,
      message: `Store is closed for today. It will open tomorrow at ${next_opening_time}.`,
    };
  }
  // Store open and closing soon
  else {
    const minsLeftToClose = storeEnd.diff(now, 'minutes');

    if (minsLeftToClose <= closingSoonMinutes) {
      if (minsLeftToClose < 60) {
        store_status = `Store closing in ${minsLeftToClose} mins`;
      } else {
        const hours = Math.floor(minsLeftToClose / 60);
        const mins = minsLeftToClose % 60;

        if (mins === 0) {
          store_status = `Store closing in ${hours} hour${hours > 1 ? 's' : ''}`;
        } else {
          store_status = `Store closing in ${hours}h ${mins}m`;
        }
      }
    }
  }

  // FIXED: if store not open yet, start from storeStart, otherwise start from now
  const baseTime = now.isBefore(storeStart) ? storeStart.clone() : now.clone();
  const slotStart = baseTime.clone().add(slotStartGap, 'minutes');
  const slotEnd = slotStart.clone().add(slotGapBetween, 'minutes');
  const deliverySlot = `${slotStart.format('hh:mm A')} - ${slotEnd.format('hh:mm A')}`;
  const deliveryDate = slotStart.format('MM/DD/YYYY');

  return {
    success: true,
    store_status,
    next_opening_time,
    delivery_date: deliveryDate,
    delivery_time_slot: deliverySlot,
    selectedDeliveryOption,
    message: 'Delivery slot generated successfully.',
  };
}

// New mehtod will create all delivery  OPTION time slots , like for pickup,standarddelivery,proritydelivery etc
export function GenerateAllTimeSlotsForDelivery({ KitchenInfoData, onLoadInfoResponse }) {
  const operation_start_time = KitchenInfoData?.operation_start_time;
  const operation_end_time = KitchenInfoData?.operation_end_time;

  const StandardDeliveryObj =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.standard_delivery;
  const PriorityDeliveryObj =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.priority_delivery;

  const now = moment();
  const slotGapBetween = 30;
  const closingSoonMinutes = 30;
  const today = now.format('MM/DD/YYYY');

  let storeStart = moment(`${today} ${operation_start_time}`, 'MM/DD/YYYY hh:mm A');
  let storeEnd = moment(`${today} ${operation_end_time}`, 'MM/DD/YYYY hh:mm A');

  // Handle overnight timing
  if (storeEnd.isSameOrBefore(storeStart)) {
    storeEnd.add(1, 'day');
  }

  const tomorrowStart = storeStart.clone().add(1, 'day');
  const next_opening_time = tomorrowStart.format('hh:mm A');

  const getStoreStatus = () => {
    let store_status = 'open';

    // Before store opens
    if (now.isBefore(storeStart)) {
      const diffMinutes = storeStart.diff(now, 'minutes');

      if (diffMinutes < 60) {
        store_status = `Store opens in ${diffMinutes} mins`;
      } else {
        const hours = Math.floor(diffMinutes / 60);
        const mins = diffMinutes % 60;

        if (mins === 0) {
          store_status = `Store opens in ${hours} hour${hours > 1 ? 's' : ''}`;
        } else {
          store_status = `Store opens in ${hours}h ${mins}m`;
        }
      }
    }
    // Store open and closing soon
    else if (now.isBefore(storeEnd)) {
      const minsLeftToClose = storeEnd.diff(now, 'minutes');

      if (minsLeftToClose <= closingSoonMinutes) {
        if (minsLeftToClose < 60) {
          store_status = `Store closing in ${minsLeftToClose} mins`;
        } else {
          const hours = Math.floor(minsLeftToClose / 60);
          const mins = minsLeftToClose % 60;

          if (mins === 0) {
            store_status = `Store closing in ${hours} hour${hours > 1 ? 's' : ''}`;
          } else {
            store_status = `Store closing in ${hours}h ${mins}m`;
          }
        }
      }
    }

    return store_status;
  };

  const buildSlotResponse = (selectedDeliveryOption, slotStartGap) => {
    // After store closes
    if (now.isSameOrAfter(storeEnd)) {
      return {
        success: false,
        store_status: 'store is closed for today',
        next_opening_time,
        delivery_date: null,
        delivery_time_slot: null,
        selectedDeliveryOption,
        message: `Store is closed for today. It will open tomorrow at ${next_opening_time}.`,
      };
    }

    const store_status = getStoreStatus();

    // If store not open yet, start from storeStart, otherwise start from now
    const baseTime = now.isBefore(storeStart) ? storeStart.clone() : now.clone();
    const slotStart = baseTime.clone().add(slotStartGap, 'minutes');
    const slotEnd = slotStart.clone().add(slotGapBetween, 'minutes');

    // Extra safety: if slot start goes beyond store closing time
    if (slotStart.isSameOrAfter(storeEnd) || slotEnd.isAfter(storeEnd)) {
      return {
        success: false,
        store_status,
        next_opening_time,
        delivery_date: null,
        delivery_time_slot: null,
        selectedDeliveryOption,
        message: `No ${selectedDeliveryOption} slot is available for today.`,
      };
    }

    const deliverySlot = `${slotStart.format('hh:mm A')} - ${slotEnd.format('hh:mm A')}`;
    const deliveryDate = slotStart.format('MM/DD/YYYY');

    return {
      success: true,
      store_status,
      next_opening_time,
      delivery_date: deliveryDate,
      delivery_time_slot: deliverySlot,
      selectedDeliveryOption,
      message: 'Delivery slot generated successfully.',
    };
  };

  //*** IMPORTANT NOTE --> If you change below for timegap then it has aslo be chnages above method AssignGap()  */
  if (KitchenInfoData?.delivered_by === 'kitchen') {
    return {
      standard: buildSlotResponse('standard', 45),
      priority: buildSlotResponse('priority', 30),
      pickup: buildSlotResponse('pickup', 20),
    };
  }

  // We have to get regionalbranch flags for this from onloadresponse
  if (KitchenInfoData?.delivered_by !== 'kitchen') {
    return {
      standard: buildSlotResponse('standard', StandardDeliveryObj?.slotStartGap),
      priority: buildSlotResponse('priority', PriorityDeliveryObj?.slotStartGap),
      pickup: buildSlotResponse('pickup', 20),
    };
  }
}
